import { CircularProgress } from "@mui/material";
import { LocalSEOAgentReport } from "../types";
import GoogleBusinessCard, { IGoogleBusinessCard } from "./GoogleBusinessCard";
import LocalRankingInsightsCard, { ILocalRankingInsightsCard } from "./LocalRankingInsights";
import LSNoDataFound from "./LSNoDataFound";
import WeeklySummaryCard from "./WeeklySummaryCard";
import { useMemo } from "react";
import { IGBPLocation } from "../../hooks/useSiteGBP1to1Maping";

interface ILocalSEOAI {
  selectedProfile: IGBPLocation;
  hasReport: boolean;
  data: LocalSEOAgentReport;
  isLoading: boolean;
  isPending: boolean;
}

export default function LocalSEOAI(props: ILocalSEOAI) {

  const weeklySummary = useMemo(() => {
    return {
      healthScore: {
        value: props?.data?.weekly_summary?.healthScore,
        trend: props?.data?.weekly_summary?.scoreChange
      },
      newReviews: props?.data?.weekly_summary?.newReviews,
      pendingReplies: props?.data?.weekly_summary?.pendingReviewReplies,
      issuesFound: props?.data?.weekly_summary?.issuesDetected,
      completedFixes: props?.data?.weekly_summary?.completedFixes,
      recommendations: props?.data?.weekly_summary?.topRecommendation?.map((rec) => ({
        text: rec.title,
        impact: rec.impact
      })) || []
    };
  }, [props.data]);

  const googleBusiness = useMemo<IGoogleBusinessCard>(() => {
    return {
      sections: props?.data?.gbp_health?.sections,
      healthScore: {
        value: props?.data?.ranking?.summary?.visibility,
        change: props?.data?.ranking?.summary?.visibilityChange
      }
    };
  }, [props.data]);

  const rankingInsights = useMemo<ILocalRankingInsightsCard>(() => {
    return {
      rankingInsights: props?.data?.actions,
      accountId: props?.data?.location?.account_id,
      locationId: props?.data?.location?.location_id,
      healthScore: {
        value: props?.data?.weekly_summary?.healthScore,
        change: props?.data?.weekly_summary?.scoreChange
      },
    };
  }, [props.data]);

  return (
    <>
      {(props.isLoading || props.isPending) ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', justifyContent: 'center', alignItems: 'center', minHeight: 'calc(100vh - 173px)', textAlign: 'center' }}>
          <CircularProgress size={64} />
          <p className="font-semibold text-lg text-[#1D2939] mt-2">
            Orbit AI Local SEO is running...
          </p>
          <p className="font-normal text-sm text-[#667085] max-w-md">
            This may take a few moments while we analyze your Google Business Profile and local search performance.
          </p>
        </div>
      ) : (
        <>
          {props.hasReport ? (
            <>
              <div aria-label="weekly-summary-card">
                <WeeklySummaryCard {...weeklySummary} />
              </div>

              <div className="mt-4" aria-label="google-business-card">
                <GoogleBusinessCard {...googleBusiness} />
              </div>

              <div aria-label="local-ranking-insights-card" className="mt-4">
                <LocalRankingInsightsCard {...rankingInsights} />
              </div>
            </>
          ) : (
            <LSNoDataFound selectedProfile={props.selectedProfile} />
          )}
        </>
      )}
    </>
  );
}
